import Avatar from "components/BaseWidgets/Avatar";
import Popover from "components/BaseWidgets/popover";
import "./style.scss";
import Divider from "components/BaseWidgets/divider";
import { LogoutIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import { links } from "./helper";
import { useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import { useProfileCompletion } from "hooks/api/useHome";
import { useReferModal } from "context/ReferModalProvider";
import { useFeedBack } from "context/FeedBackModelContext";

import { useNavigate } from "react-router-dom";

function HederMenu({ setLogoutModal }) {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const { data: userData, isLoading } = useProfileCompletion();
  // const { setReferOpen } = useReferModal();
  const { setFeedBackOpen } = useFeedBack();

  const content = (
    <div className="header-menu-wrapper">
      <div className="">
        {links.map((item) => (
          <Button
            variant="custom"
            key={item?.key}
            className="flex items-center gap-1-5 item-container"
            onClick={() => {
              if (item.label === "Refer a friend") {
                navigate(item.href, { state: item.state });
                setOpen(false);
              } else if (item.label === "Feedback") {
                setFeedBackOpen(true);
                setOpen(false);
              } else if (item.href) {
                navigate(item.href, { state: item.state });
                setOpen(false);
              }
            }}
          >
            <span className="icon">{item?.icon && <item.icon />}</span>
            <span className="link-text">{item?.label}</span>
          </Button>
        ))}
      </div>
      <Divider />
      <Button
        onClick={() => {
          setLogoutModal(true);
          setOpen(false);
        }}
        variant="custom"
        className="flex items-center gap-1-5 item-container"
      >
        <span className="icon">
          <LogoutIcon />
        </span>
        <span className="link-text">Log out</span>
      </Button>
    </div>
  );

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={(value) => setOpen(value)}
      content={content}
    >
      <span>
        <Avatar
          isLoading={isLoading}
          url={userData?.common_home_data?.user_image}
          icon={<UserOutlined />}
          size={42}
          className="profile-pic-pointer pointer"
        />
      </span>
    </Popover>
  );
}

export default HederMenu;
